import { useEffect, useState } from "react";
import Helmet from 'react-helmet'
import { useParams } from "react-router-dom";
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { Link } from 'react-router-dom';
import albaranesService from "../../services/albaranes.service";
import { useSnackbar } from 'notistack'
import { useHistory } from 'react-router-dom'
import { Box, CircularProgress } from "@mui/material";
import { insertDevoluciones } from "../../common/features/albaranes/albaranesSlice";
import { useDispatch } from "react-redux";
import useModal from "../../common/hooks/useModal";
import { formatDate } from "../../helpers";
import { DevolucionesPopover, useDevolucionesPopover } from "../../components/albaranes/DevolucionesPopover";

export default function HistoricalAlbaran() {
  let { albaranId } = useParams();
  const [albaran, setAlbaran] = useState(null)
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory()
  const dispatch = useDispatch()
  const modal = useModal()

  const devolucionesPopover = useDevolucionesPopover();

  useEffect(() => {
    async function fetchAlbaranInfo() {
      await albaranesService.getById({ albaranId })
      .then(response => {
        if (response.id_albaran && response.detalles){
          setAlbaran({
            detalles: response.detalles,
            id_albaran: response.id_albaran,
            numero_albaran: response.numero_albaran,
            numero_albaran_dev: response.numero_albaran_dev,
            fecha_albaran: response.fecha_albaran,
            total: response.total,
          })
        } else {
          enqueueSnackbar(response.message, {
            variant: 'error'
          })
          history.push('/historical-albaranes')
        }
      })
      .catch(err => {
        enqueueSnackbar(err.message, {
          variant: 'error'
        })
        history.push('/historical-albaranes')
      })
    }
    fetchAlbaranInfo()
  }, [albaranId]);

  if (!albaran) {
    return (
      <>
        <Box sx={{ mt: 12, textAlign: 'center' }}>
          <CircularProgress size={24} color="secondary" />
        </Box>
      </>
    );
  }

  return (
    <>
      <h3>Núm. Albarán: {albaran.numero_albaran_dev || albaran.numero_albaran}
        <span style={{ display: 'block', fontWeight: 'normal', color: '#666', fontSize: '0.9em' }}>
          {formatDate(new Date(albaran.fecha_albaran), "es-ES", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })}
        </span>
      </h3>
      <Helmet>
        <title>Devoluciones - Marina BCN</title>
      </Helmet>
      <TableContainer component={Paper}>
        <Table  sx={{ 
            '& .MuiTableCell-root': { 
            px: 0.75
            } 
        }}>
        <TableHead>
            <TableRow>
            <TableCell sx={{ width: '70%' }}>Publicación</TableCell>
            <TableCell sx={{ width: '10%' }} align="center">Entrega</TableCell>
            <TableCell sx={{ width: '10%' }} align="center">Devol. inform. </TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            { albaran.detalles.map((detalle, index) => (
            <TableRow
                key={detalle.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                <TableCell sx={{ fontSize: '0.8rem' }}>{ detalle.nombre_articulo }</TableCell>
                <TableCell align="center">{ detalle.ejemplares_venta || 0 }</TableCell>
                <TableCell align="center">
                  {detalle.devoluciones_log?.length > 0 ? (
                    <Box
                      component="span"
                      onClick={(event) => devolucionesPopover.toggle(event, detalle.devoluciones_log)}
                      sx={{
                        display: 'inline-flex',
                        cursor: 'pointer',
                        borderBottom: '1px dotted currentColor',
                        color: 'info.main',
                      }}
                    >
                      { detalle.devoluciones_informadas || 0 }
                    </Box>
                  ) : (
                    detalle.devoluciones_informadas || 0
                  )}
                </TableCell>
            </TableRow>
            ))}
        </TableBody>
        </Table>
      </TableContainer>
      <DevolucionesPopover
        open={devolucionesPopover.open}
        anchorEl={devolucionesPopover.anchorEl}
        onClose={devolucionesPopover.handleClose}
        items={devolucionesPopover.desglose}
      />
      <Box sx={{ my: 3 }}>
        <Button
            component={Link}
            to="/historical-albaranes"
            variant="outlined"
            color="primary"
        >
            Volver
        </Button>
      </Box>
    </>
  )
}
